import { render, staticRenderFns } from "./DocumentFormBox.vue?vue&type=template&id=507298ca&scoped=true"
import script from "./DocumentFormBox.vue?vue&type=script&lang=js"
export * from "./DocumentFormBox.vue?vue&type=script&lang=js"
import style0 from "vue-search-select/dist/VueSearchSelect.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./DocumentFormBox.vue?vue&type=style&index=2&id=507298ca&prod&lang=css"
import style3 from "./DocumentFormBox.vue?vue&type=style&index=3&id=507298ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507298ca",
  null
  
)

export default component.exports